const sortPosition = (a, b) => {
  const posA = parseInt(a?.position?.[0] || a.position?.[0]);
  const posB = parseInt(b?.position?.[0] || b.position?.[0]);
  return !isNaN(posA) && !isNaN(posB)
    ? posA - posB
    : isNaN(posA) && isNaN(posB)
    ? 0
    : isNaN(posA)
    ? 1
    : -1;
};

export default sortPosition;
